function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 8.5,
  fill: "#A4E7DB"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 18.453L14.673 22 24 13",
  stroke: "#073331",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgCheck;